import { Box, Typography, MediaBox } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import React from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"
import styled from "styled-components"

const Container = styled(MediaBox).attrs((props) => ({
  bg: "#757575",
  color: "white",
  lessThan: "tablet",
  ...props,
}))`
  display: flex;
  color: white;
  flex-direction: column;
  justify-content: center;
  text-align: center;
`
const BannerText = styled(Typography).attrs((props) => ({
  as: "span",
  fontSize: { _: "16px", tablet: "13px" },
  lineHeight: 1,
  ...props,
}))``
const InternalMicrobanner = ({ collectionmicrobanner }) => {
  if (!collectionmicrobanner.text) return ""
  return (
    <Container {...collectionmicrobanner.style}>
      <Box
        as={collectionmicrobanner.url ? Link : "div"}
        data-lc="microbanner"
        py={1}
        to={collectionmicrobanner.url}
      >
        <BannerText
          dangerouslySetInnerHTML={{
            __html: collectionmicrobanner.text,
          }}
        />
      </Box>
    </Container>
  )
}

const mapStateToProps = (state) => {
  return {
    collectionmicrobanner: state.sale.collectionmicrobanner,
  }
}

const mapDispatchToProps = () => {
  return {}
}

InternalMicrobanner.propTypes = {
  collectionmicrobanner: PropTypes.object,
}

const Microbanner = connect(
  mapStateToProps,
  mapDispatchToProps
)(InternalMicrobanner)

export default Microbanner
